import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Assignee from 'components/sales/formSection/assignee/assignee';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const ChangeAssignee = ({
  getAssigneeList,
  assigneeList,
  match,
  postAssignee,
  newAssignee,
  newAssigneeRes=[]
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setsiteId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const inputs = {
    ids: [match.params.siteId],
    new_assigned_id:'',
    type:2
  };
  const [assigneeData, setAssigneeData] = useState(inputs);
  const [isSiteAssignPending, setIsSiteAssignPending] = useState(false)

  useEffect(() => {
    setsiteId(match.params.siteId);
    (async () => {
      if (siteId) {
        setIsLoading(true);
        await getAssigneeList(siteId);
        setIsLoading(false);
      }
    })();
  }, [siteId]);

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };
  const handleModalHide = () => setIsModal(false);
  const handleSubmit = async () => {
    const { assigneeDetail } = assigneeData;

    if (assigneeDetail === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      setIsModal(true);
      setIsLoading(true);

      const res = await newAssignee({
        'new_assigned_id':assigneeDetail?.user_id,
        'ids':[parseInt(match?.params?.siteId)],
        'type':2
      });
      setIsLoading(false);
      if (res) getAssigneeList(siteId);
    }
  };

  useEffect(() => {
    setIsSiteAssignPending(false)
    if(assigneeList?.current_assignee !==undefined && assigneeList?.current_assignee[0] !== undefined &&
        assigneeList?.current_assignee[0]?.change_assignee_status !== undefined
        && parseInt(assigneeList?.current_assignee[0]?.change_assignee_status) === 1){
          setIsLoading(true)
            setIsSiteAssignPending(true)
          setIsLoading(false)
    }
  }, [assigneeList])

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={localization.changeAssignee}
      Buttons={isSiteAssignPending ? "" :  headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      {console.log(isSiteAssignPending)}
      <Assignee
        assigneeList={assigneeList}
        siteId={siteId}
        handleValue={handleAssignee}
        isBulkAssignment={true}
        baAssignee={true}
        isSiteAssignPending={isSiteAssignPending}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/brand-activation/sites-listing`}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

ChangeAssignee.propTypes = {};

export default ChangeAssignee;
